import { inject, InjectionToken } from '@angular/core';
import { CashRegisterReplicationService } from '../cash-register-replication.service';
import { CashRegisterStore } from './cash-register-sync.models';

/**
 * The cash register store — Firestore, the source of truth.
 *
 * The token stays so the store is chosen in one place and consumers depend on
 * the {@link CashRegisterStore} contract rather than on an implementation.
 */
export const CASH_REGISTER_STORE = new InjectionToken<CashRegisterStore>('CASH_REGISTER_STORE', {
  providedIn: 'root',
  factory: () => inject(CashRegisterReplicationService)
});
